import { useEffect, useState } from "react";
import Modal from "../Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import * as api from "../../api/sanha";

const CAR_NUMBER_ERROR_MESSAGE = `
차량번호 형식이 올바르지 않습니다.
(공백, 특수문자 입력 불가)

가능한 번호 형식:
1) 12가1234
2) 123가1234
3) 서울12가1234
`;

const validateCarNumber = (carNumber) => {
  const carNumberRegex = /^([0-9]{2,3}[가-힣][0-9]{4}|[가-힣]{2,3}[0-9]{1,2}[가-힣][0-9]{4})$/;

  return carNumberRegex.test(carNumber);
};

const ParkingModal = ({ onClose, bookingItem: { car_Update_YN, car_Cnt }, urlQueryStringParams }) => {
  const [vehicles, setVehicles] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [inputValue, setInputValue] = useState("");

  const fetchCarList = async () => {
    try {
      const { data } = await api.getCarList(urlQueryStringParams);
      setVehicles(Array.from({ length: car_Cnt }, (_, i) => data.resultData[i] || null));
    } catch (error) {
      console.error("차량 목록 조회 에러:", error);
    }
  };

  const updateCarNumber = async (cud_Type, car_id, car_No) => {
    try {
      await api.updateCarNumber({
        ...urlQueryStringParams,
        cud_Type,
        car_id,
        car_No,
      });
      await fetchCarList();
    } catch (error) {
      console.error("차량 번호 업데이트 에러:", error);
    }
  };

  const handleEditClick = (index) => {
    setEditIndex(index);
    setInputValue(vehicles[index]?.carNo || "");
  };

  const handleSaveEdit = () => {
    if (editIndex === null) return;

    const current = vehicles[editIndex];
    const trimmed = inputValue.trim();

    // 빈 값 입력 → 삭제
    if (trimmed === "") {
      if (!current?.seqNo) return; // 새 항목에 빈값 저장 무시
      updateCarNumber("D", current.seqNo, "");
      closeEdit();
      return;
    }

    // 검증 실패
    if (!validateCarNumber(trimmed)) {
      alert(CAR_NUMBER_ERROR_MESSAGE);
      return;
    }

    // 생성 또는 수정
    const cud_Type = current?.seqNo ? "U" : "C";
    const car_id = current?.seqNo ?? "";

    updateCarNumber(cud_Type, car_id, trimmed);
    closeEdit();
  };

  const closeEdit = () => {
    setEditIndex(null);
    setInputValue("");
  };

  useEffect(() => {
    fetchCarList();
  }, []);

  return (
    <Modal
      isOpen
      onClose={onClose}
      Content={
        <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
          <p style={{ textAlign: "center", margin: 0 }}>무료 출차를 위해 차량을 등록해 주세요.</p>
          <div>
            <div
              style={{
                maxHeight: "320px",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                marginBottom: "8px",
                padding: "16px 12px",
                backgroundColor: "#eeeeee",
                borderRadius: "4px",
                overflowY: "scroll",
              }}
            >
              {Array.from({ length: car_Cnt }).map((_, i) => {
                const vehicle = vehicles[i];
                const disabled = i > 0 && !vehicles[i - 1]?.carNo;

                return (
                  <div key={i} style={{ textAlign: "center" }}>
                    {editIndex === i ? (
                      <div style={{ display: "flex", gap: "8px" }}>
                        <input
                          type="text"
                          placeholder="12가1234"
                          value={inputValue}
                          onChange={(e) => setInputValue(e.target.value)}
                          autoFocus
                          style={{
                            flex: 1,
                            padding: "10px 8px",
                            fontSize: "14px",
                            border: "1px solid #6a6a6a",
                            borderRadius: "4px",
                            backgroundColor: "white",
                          }}
                        />
                        <button onClick={handleSaveEdit} className="parking-modal-button">
                          저장
                        </button>
                      </div>
                    ) : vehicle === null ? (
                      <div style={{ border: "1px solid #bbb", borderRadius: "4px", padding: "4px 0" }}>
                        <button style={{ all: "unset" }} onClick={() => handleEditClick(i)} disabled={disabled}>
                          <FontAwesomeIcon icon={faPlusCircle} size="2x" color={disabled ? "lightGray" : ""} />
                        </button>
                      </div>
                    ) : (
                      <div style={{ display: "flex", gap: "8px" }}>
                        <div
                          style={{
                            display: "flex",
                            flex: 1,
                            fontSize: "14px",
                            alignItems: "center",
                            padding: "8px",
                            backgroundColor: "white",
                            borderRadius: "4px",
                          }}
                        >
                          {vehicle?.carNo || ""}
                        </div>
                        {car_Update_YN === "Y" && vehicle?.car_Update_YN === "Y" && (
                          <button onClick={() => handleEditClick(i)} className="parking-modal-button">
                            수정
                          </button>
                        )}
                      </div>
                    )}
                    {vehicle?.lastUpdDt && (
                      <span style={{ display: "block", fontSize: "12px", color: "#6a6a6a", textAlign: "end" }}>{vehicle.lastUpdDt}</span>
                    )}
                  </div>
                );
              })}
            </div>
            <span
              style={{
                display: "block",
                fontSize: "14px",
                color: "#6a6a6a",
                lineHeight: "1.6",
              }}
            >
              ※ 무료주차 등록 가능 대수
              <br />
              - 46평형 미만 : 2대
              <br />
              - 46평형 이상 : 3대
              <br />
              ※ 현재 무료 운영 중입니다.
              <br />
              (추후 유료 전환 예정)
            </span>
          </div>

          <button
            onClick={onClose}
            style={{
              width: "100%",
              padding: "14px 0",
              backgroundColor: "#8fb0cf",
              border: "none",
              color: "white",
              borderRadius: "4px",
              fontSize: "16px",
              fontWeight: 500,
            }}
          >
            닫기
          </button>
        </div>
      }
    />
  );
};

export default ParkingModal;
